import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { StoreLayout } from "@/components/StoreLayout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Auth from "@/pages/Auth";
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const Account = lazy(() => import("@/pages/Account"));
const Favorites = lazy(() => import("@/pages/Favorites"));
const OrderConfirmation = lazy(() => import("@/pages/OrderConfirmation"));
const CampaignBuilder = lazy(() => import("@/pages/CampaignBuilder"));
const DateDeals = lazy(() => import("@/pages/DateDeals"));
const AdminLayout = lazy(() => import("@/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/admin/Dashboard"));
const AdminProducts = lazy(() => import("@/admin/AdminProducts"));
const AdminCategories = lazy(() => import("@/admin/AdminCategories"));
const AdminOrders = lazy(() => import("@/admin/AdminOrders"));
const AdminCustomers = lazy(() => import("@/admin/AdminCustomers"));
const AdminOffers = lazy(() => import("@/admin/AdminOffers"));
const AdminDesign = lazy(() => import("@/admin/AdminDesign"));
const AdminHomepage = lazy(() => import("@/admin/AdminHomepage"));
const AdminVideo = lazy(() => import("@/admin/AdminVideo"));
const AdminSettings = lazy(() => import("@/admin/AdminSettings"));
const AdminPaymentProvider = lazy(() => import("@/admin/AdminPaymentProvider"));
const AdminAI = lazy(() => import("@/admin/AdminAI"));
const AdminSlides = lazy(() => import("@/admin/AdminSlides"));
const AdminGraphicLayout = lazy(() => import("@/admin/AdminGraphicLayout"));
const AdminDateDeals = lazy(() => import("@/admin/AdminDateDeals"));
const POS = lazy(() => import("@/admin/pos/POS"));

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
          <Suspense fallback={<div style={{ minHeight: "60vh" }} />}>
          <Routes>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/produkter" element={<Shop mode="all" />} />
              <Route path="/kategori/:slug" element={<Shop mode="category" />} />
              <Route path="/tilbud" element={<Shop mode="offers" />} />
              <Route path="/datovare" element={<DateDeals kind="datovare" />} />
              <Route path="/stop-spild" element={<DateDeals kind="stop_spild" />} />
              <Route path="/kampagne/:id" element={<CampaignBuilder />} />
              <Route path="/produkter/:slug" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/ordre-bekraeftelse" element={<OrderConfirmation />} />
              <Route path="/konto" element={<Account />} />
              <Route path="/favoritter" element={<Favorites />} />
            </Route>
            <Route path="/login" element={<Auth />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="pos" element={<POS />} />
              <Route path="produkter" element={<AdminProducts />} />
              <Route path="ai" element={<AdminAI />} />
              <Route path="kategorier" element={<AdminCategories />} />
              <Route path="ordrer" element={<AdminOrders />} />
              <Route path="kunder" element={<AdminCustomers />} />
              <Route path="tilbud" element={<AdminOffers />} />
              <Route path="datovare" element={<AdminDateDeals kind="datovare" />} />
              <Route path="stop-spild" element={<AdminDateDeals kind="stop_spild" />} />
              <Route path="design" element={<AdminDesign />} />
              <Route path="slides" element={<AdminSlides />} />
              <Route path="grafisk-layout" element={<AdminGraphicLayout />} />
              <Route path="forside" element={<AdminHomepage />} />
              <Route path="video" element={<AdminVideo />} />
              <Route path="indstillinger" element={<AdminSettings />} />
              <Route path="betaling/:key" element={<AdminPaymentProvider />} />
            </Route>
          </Routes>
          </Suspense>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
